<div class="container-fluid registerBgImg">
<div class="row registerArea">
	<div class="col-lg-4 offset-lg-4">
		<div class="card p-4 register_form">
			<form #formpost="ngForm" method="post" (ngSubmit)="formpost.form.valid && onSubmit(formpost)">
				<div class="text-center register_title">
					<h4>Create an account</h4>
				</div>
				<div class="form-group pt-4">
					<label for="email">Email</label>
					<input type="email" name="email" class="form-control register_input" ngModel #email="ngModel" required="required"  #email="ngModel" placeholder="abc@gmail.com" [ngClass]="{ 'is-invalid': formpost.submitted && email.invalid }" required [email]="true">
					<div *ngIf="formpost.submitted && email.invalid" class="invalid-feedback">
                       <div *ngIf="email.errors.required">Email is required</div>
                       <div *ngIf="email.errors.email">Email must be a valid email address</div>
                    </div>
				</div>												
				<div class="form-group">
					<label for="m_number">Mobile Number</label>
					<input type="number" name="phone" class="form-control register_input" ngModel #phone="ngModel" required="required" [ngClass]="{ 'is-invalid': formpost.submitted && phone.invalid }" maxlength="10">
					<div *ngIf="formpost.submitted && phone.invalid" class="invalid-feedback">
                       <div *ngIf="password.errors.required">Phone number is required</div>
                    </div>
				</div>
				<div class="form-group">
					<label for="password">Password</label>
					<input type="password" name="password" class="form-control register_input" ngModel #password="ngModel" required="required" [ngClass]="{ 'is-invalid': formpost.submitted && password.invalid }">
					<div *ngIf="formpost.submitted && password.invalid" class="invalid-feedback">
                       <div *ngIf="password.errors.required">Password is required</div>
                    </div>
				</div>
				<input type="submit" name="submit" class="form-control btn btn-primary my-3 register_continue" value="Continue">
			</form>
			<a routerLink="/login">Already have an account?</a>
			<p class="policy_service mt-3">By registering you agree to Data Pitcher's <a href="#">Term of service</a> and <a href="#">Privacy policy</a></p>
		</div>
	</div>
</div>
</div>


